module.exports = __webpack_public_path__ + "img/partnerOrange.7e5f9635.jpg";